export default __webpack_public_path__ + "static/media/689.0770a3d5.gif";